import { type SetStateAction } from "react";
import input from "../../../../assets/styles/components/input.module.css";
import styles from "./Filter.module.css";
import ModalGeneric from "../../../../components/ModalGeneric/ModalGeneric";

interface prop {
  dataFilter: {
    tipo: string;
    status: string;
  };
  setDataFilter: React.Dispatch<
    SetStateAction<{
      tipo: string;
      status: string;
    }>
  >;
  onClose: () => void;
}

const Filter = ({ onClose, dataFilter, setDataFilter }: prop) => {
  const handleChange = (e: string, field: string) => {
    setDataFilter((prev) => ({ ...prev, [field]: e }));
  };

  return (
    <ModalGeneric
      onClick={onClose}
      title="Filtrar Contas"
      modalGenericCustom={styles.modalCustom}>
      <div className={styles.filter}>
        <label>
          Tipo
          <select
            className={input.input}
            value={dataFilter.tipo}
            onChange={(e) => handleChange(e.target.value, "tipo")}>
            <option value="">Todos</option>
            <option value="caixa">Caixa</option>
            <option value="banco">Banco</option>
            <option value="pix">Pix</option>
            <option value="carteira">Carteira</option>
            <option value="outro">Outro</option>
          </select>
        </label>
        <label>
          Status
          <select
            className={input.input}
            value={dataFilter.status}
            onChange={(e) => handleChange(e.target.value, "status")}>
            <option value="1">Ativo</option>
            <option value="0">Inativo</option>
          </select>
        </label>
      </div>
    </ModalGeneric>
  );
};

export default Filter;
